<template>
  <div id="app" ref="app">
    <router-view v-if="isRouterShow" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterShow: true
      }
    },
    created() {
      document.addEventListener('visibilitychange', () => {
        this.$store.commit('app/SET_DOCUMENT_VISIBILITY', document.hidden ? false : true);
      });
    },
    mounted() {
      if (this._isMobile()) {
        if (window.location.hash.split('?')[0] != '#/examination/examinationpaper') {
          let url = 'http://' + window.location.hostname
          let port = window.location.port
          let dict_port = {
            '12301': '8080', //本地
            '11101': '11104', //北京
            '11301': '11304', //河北
            '11501': '11504', //内蒙
            '13201': '13204', //江苏
            '14101': '14104', //河南
            '14401': '14404', //广东
            '11601': '11604', //综合
          }
          const appPort = dict_port[port]
          // alert("手机端");
          window.location.href = url + ':' + appPort
        }
      }
    },
    methods: {
      async reload() {
        this.isRouterShow = false
        await this.$nextTick()
        this.isRouterShow = true
      },
      //App.vue，判断是否为移动端
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      }
    }
  }
</script>
